import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { currentSelectedLanguage, setDocumentTemplates, storeTemplateIdentifyLeakers } from "../../../../StateManagement/actions";
import DualListSelector from "./DualListSelector";
import APIRequest from "../../../../Services/commonAPIConsumer";
import LoadingSpinner from "../../../Controls/Spinner/LoadingSpinner";
import Alert from "../../../Controls/Alerts/Alerts";

const EditTemplate = ({
    isOpen,
    Template,
    handleCancel,
    sortedColumns,
    LEVEL1_ALLOWED,
    LEVEL2_ALLOWED,
    maxReadsText,
    maxViewsPerDocumentText,
    maxPrintsPerReaderText,
    maxPrintsPerDocumentText,
    ConstContinents,
    ConstMultipleIps,
    Domains
}) => {
    const selectedLanguage = useSelector(currentSelectedLanguage);
    const [templateName, setTemplateName] = useState("");
    const [securityLevel, setSecurityLevel] = useState(1);
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [openLoader, setOpen] = useState(false);
    const [isSecurityLevelChanged, setIsSecurityLevelChanged] = useState(false);
    const [openLoaderSearch, setOpenLoaderSearch] = useState(false);
    const [maxReadsPerReader, setMaxReadsPerReader] = useState(Template.maxReadsPerReader);
    const [maxViewsPerDocument, setMaxViewsPerDocument] = useState(Template.maxViewsPerDocument);
    const [maxPrintsPerReader, setMaxPrintsPerReader] = useState(Template.maxPrintsPerReader);
    const [maxPrintsPerDocument, setMaxPrintsPerDocument] = useState(Template.maxPrintsPerDocument);
    const [restrictToDomains, setRestrictToDomains] = useState(Template.domains || Template.restrictToDomains || "");
    const [allowedIP, setAllowedIP] = useState(Template.allowedIP);
    const [bannedRegions, setBannedRegions] = useState(Array.isArray(Template.bannedRegions) ? Template.bannedRegions : []);
    const [alertMsg, setAlertMsg] = useState("");
    const [alertType, setAlertType] = useState("");
    const [alertClass, setAlertClass] = useState("alertindex");
    const dispatch = useDispatch();
    const templateNameRef = useRef(false);
    const TemplatesData = useSelector((state) => state.documentTemplates.docTemplateOptions);
    const templateIdentifyLeakers = useSelector((state) => state.templateIdentifyLeakers);
    useEffect(() => {
        if (!Template) return;

        setMaxReadsPerReader(Template.maxReadsPerReader || 0);
        setMaxViewsPerDocument(Template.maxViewsPerDocument || 0);
        setMaxPrintsPerReader(Template.maxPrintsPerReader || 0);
        setMaxPrintsPerDocument(Template.maxPrintsPerDocument || 0);
        setRestrictToDomains(Template.domains || Template.restrictToDomains || "");
        setAllowedIP(
            Array.isArray(Template.allowedIP)
                ? Template.allowedIP.filter(Boolean).join(",")
                : (Template.allowedIP || "")
        );
        setBannedRegions(
            Array.isArray(Template.bannedRegions)
                ? Template.bannedRegions.map(Number).filter(n => !isNaN(n))
                : []
        );
    }, [Template]);
    useEffect(() => {
        if (!Template || !isOpen) return;
        setTemplateName(Template.templateName || "");
        setSecurityLevel(Template.rDocsLevel || 1);
        dispatch(storeTemplateIdentifyLeakers({
            cipherText: Template.cipherText || [],
            floatingText: Template.floatingText || []
        }));
        setMaxReadsPerReader(Template.maxReadsPerReader || 0);
        setMaxViewsPerDocument(Template.maxViewsPerDocument || 0);
        setMaxPrintsPerReader(Template.maxPrintsPerReader || 0);
        setMaxPrintsPerDocument(Template.maxPrintsPerDocument || 0);
        setRestrictToDomains(Template.domains || Template.restrictToDomains || "");

        setAllowedIP(
            Array.isArray(Template.allowedIP)
                ? Template.allowedIP.filter(Boolean).join(",")
                : (Template.allowedIP || "")
        );
        setBannedRegions(
            Array.isArray(Template.bannedRegions)
                ? Template.bannedRegions.map(Number).filter(n => !isNaN(n))
                : []
        );

        setSelectedFeatures([]);
    }, [Template, isOpen]);
    //     useEffect(() => {
    //     if (!isSecurityLevelChanged) {
    //         setMaxReadsPerReader(maxReadsText || 0);
    //         setMaxViewsPerDocument(maxViewsPerDocumentText || 0);
    //         setMaxPrintsPerReader(maxPrintsPerReaderText || 0);
    //         setMaxPrintsPerDocument(maxPrintsPerDocumentText || 0);
    //     }
    // }, [maxReadsText, maxViewsPerDocumentText, maxPrintsPerReaderText, maxPrintsPerDocumentText]);
    // useEffect(() => {
    //     if (!alertType) return;
    //     const timer = setTimeout(() => {
    //         setAlertMsg("");
    //         setAlertType("");
    //         setAlertClass("alertindex");
    //     }, 5000);
    //     return () => clearTimeout(timer);
    // }, [alertType]);
    const showWarning = (msg) => {
        setAlertMsg(msg);
        setAlertType("warning");
    };
    if (!isOpen) return null;
    const TEMPLATE_FEATURE_MAP = {
        sendVerifiCationCodeText: selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
        sendVerifiCationCodeEmail: selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
        idLeakers: selectedLanguage.LstLanguageCodes.UI_IDLeakers,
        proofOfSending: selectedLanguage.LstLanguageCodes.UI_ProofOfSending,
        notificationOfReading: selectedLanguage.LstLanguageCodes.UI_NotificationofReading,
        timestamp: selectedLanguage.LstLanguageCodes.UI_TimeStamp,
        voteSharing: selectedLanguage.LstLanguageCodes.UI_ShareVotes,
        voting: selectedLanguage.LstLanguageCodes.UI_Voting,
        canPrint: selectedLanguage.LstLanguageCodes.UI_CanPrint,
        distributionList: selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist,
        allowResponsesTo: selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo,
        eDisclosure: selectedLanguage.LstLanguageCodes.UI_EDisclosure,
    };
    const SecurityLevel1 = () => {
        setIsSecurityLevelChanged(true);
        setSecurityLevel(1);
    };
    const SecurityLevel2 = () => {
        setIsSecurityLevelChanged(true);
        setSecurityLevel(prev => (prev >= 2 ? 1 : 2));
    };
    const SecurityLevel3 = () => {
        setIsSecurityLevelChanged(true);
        setSecurityLevel(prev => (prev === 3 ? 2 : 3));
    };
    const handleTemplateCreation = async () => {
        if (templateName && !templateName.trim()) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseenteratemplatename);
            setAlertType("warning");
            return;
        }
        if (TemplatesData && TemplatesData.some(t => (t.id || t._id) !== (Template.id || Template.Id || Template._id) && t.templateName.trim().toLowerCase() === templateName.trim().toLowerCase())) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Templatenamealreadyexists);
            setAlertType("warning");
            return;
        }
        if (!selectedFeatures || selectedFeatures.length == 0) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOneFeature);
            setAlertType("warning");
            return;
        }
        const selectedLabels = selectedFeatures.map(f => f.label || f);

        if (selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader) && !(parseInt(maxReadsPerReader) > 0)) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReaderCannotBeEmpty);
            setAlertType("warning");
            return;
        }
        if (selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument) && !(parseInt(maxViewsPerDocument) > 0)) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocumentCannotBeEmpty);
            setAlertType("warning");
            return;
        }
        const readsSelected = selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader);
        const viewsSelected = selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument);
        if (readsSelected === viewsSelected && parseInt(maxReadsPerReader) > parseInt(maxViewsPerDocument)) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Readsperreadercannotexceedviewsperdocument);
            setAlertType("warning");
            return;
        }
        if (parseInt(maxPrintsPerReader) > parseInt(maxPrintsPerDocument)) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
            setAlertType("warning");
            return;
        }
        const isCanPrintSelected = selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_CanPrint)

        try {
            setOpen(true);
            setOpenLoaderSearch(true);

            const DocumentTemplateOptions = {
                Id: Template.id || Template.Id || Template._id,
                RDocsLevel: securityLevel,
                TemplateName: templateName,
                SendVerifiCationCodeText: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText
                ),
                IDLeakers: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_IDLeakers
                ),
                ProofOfSending: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_ProofOfSending
                ),
                CanPrint: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_CanPrint
                ),
                AllowResponsesTo: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo
                ),
                NotificationOfReading: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_NotificationofReading
                ),
                Voting: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_Voting
                ),
                DistributionList: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist
                ),
                Timestamp: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_TimeStamp
                ),
                EDisclosure: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_EDisclosure
                ),
                VoteSharing: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_ShareVotes
                ),
                SendVerifiCationCodeEmail: selectedLabels.includes(
                    selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail
                ),
                MaxReadsPerReader: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader)
                    ? (parseInt(maxReadsPerReader) || 0) : 0,
                MaxViewsPerDocument: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument)
                    ? (parseInt(maxViewsPerDocument) || 0) : 0,
                MaxPrintsPerReader: isCanPrintSelected ? (parseInt(maxPrintsPerReader) || 0) : 0,
                MaxPrintsPerDocument: isCanPrintSelected ? (parseInt(maxPrintsPerDocument) || 0) : 0,
                CipherText: templateIdentifyLeakers.cipherText,
                FloatingText: templateIdentifyLeakers.floatingText,
                Ips: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_AllowedIP)
                    ? (allowedIP ? allowedIP.split(",").map(ip => ip.trim()).filter(Boolean) : [])
                    : [],
                Regions: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_BannedRegions)
                    ? (Array.isArray(bannedRegions) ? bannedRegions : [])
                    : [],
                Domains: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_RestrictToDomains)
                    ? (restrictToDomains || "")
                    : "",

            };

            if (DocumentTemplateOptions.Voting == false && DocumentTemplateOptions.VoteSharing == true) {
                setAlertMsg(selectedLanguage.LstLanguageCodes.UI_VotingIsMandatory);
                setAlertType("warning");
                setOpen(false);
                return;
            }

            const formData = new FormData();
            const isEditTemplate = "true";
            formData.append("isEditTemplate", isEditTemplate);
            formData.append(
                "DocumentTemplateEditOptions",
                JSON.stringify(DocumentTemplateOptions)
            );

            const response = await APIRequest.POST(
                formData,
                `${process.env.REACT_APP_API}/docs/DocumentTemplate`
            );
            dispatch(setDocumentTemplates(response?.docTemplateOptions));
            dispatch(storeTemplateIdentifyLeakers({
                cipherText: response?.docTemplateOptions?.cipherText || [],
                floatingText: response?.docTemplateOptions?.floatingText || []
            }));
            handleCancel();
            setOpen(false);
            setOpenLoaderSearch(false);
            templateNameRef.current = false;
        } catch (err) {
            console.error("Template update error:", err);
            setOpen(false);
            setOpenLoaderSearch(false);
        }
    };


    return (
        <>
            <div>
                <div
                    className="modal"
                    id="MoveFolder"
                    style={{ display: "block", backgroundColor: "#8080801c" }}
                >
                    <div
                        className="modal-dialog modal-dialog-centered modal-customelg"
                        style={{ maxWidth: "830px" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header pb-1">
                                <h4 className="d-flex align-items-center text-danger fw-bold">
                                    {selectedLanguage.LstLanguageCodes.UI_EditTemplate}
                                </h4>
                            </div>

                            <div className="modal-body justify-content-center">
                                {/* SECURITY LEVELS */}
                                <div className="d-flex justify-content-center gap-3 mt-2">
                                    <ul className="ks-cboxtags ps-0 mx-margin ms-2">
                                        <li style={{ width: '230px' }}>
                                            <input
                                                className="btn-check"
                                                type="checkbox"
                                                name="securitylevels"
                                                id="securitylevel1"
                                                checked={securityLevel >= 1}
                                                onChange={SecurityLevel1}
                                            />
                                            <label
                                                className="views pb-3p"
                                                htmlFor="securitylevel1"
                                                title={selectedLanguage.LstLanguageCodes.UI_TrackViews}
                                            >
                                                <span className="w-106px truncate">
                                                    {selectedLanguage.LstLanguageCodes.UI_TrackViews}
                                                </span>
                                            </label>
                                        </li>
                                    </ul>
                                    <ul className="ks-cboxtags ps-0 mx-margin ms-12px">
                                        <li style={{ width: '230px' }}>
                                            <input
                                                className="btn-check"
                                                type="checkbox"
                                                name="securitylevels"
                                                id="securitylevel2"
                                                checked={securityLevel >= 2}
                                                onChange={SecurityLevel2}
                                            />
                                            <label
                                                className="readers pb-3p"
                                                htmlFor="securitylevel2"
                                                title={selectedLanguage.LstLanguageCodes.UI_TrackReaders}
                                            >
                                                <span className="w-118px truncate">
                                                    {selectedLanguage.LstLanguageCodes.UI_TrackReaders}
                                                </span>
                                            </label>
                                        </li>
                                    </ul>
                                    <ul className="ks-cboxtags ps-0 mx-margin ms-12px">
                                        <li style={{ width: '230px' }}>
                                            <input
                                                className="btn-check"
                                                type="checkbox"
                                                name="securitylevels"
                                                id="securitylevel3"
                                                checked={securityLevel >= 3}
                                                onChange={SecurityLevel3}
                                            />
                                            <label
                                                className="restrict pb-3p"
                                                htmlFor="securitylevel3"
                                                title={selectedLanguage.LstLanguageCodes.UI_LimitReaders}
                                            >
                                                <span className="w-120px truncate">
                                                    {selectedLanguage.LstLanguageCodes.UI_LimitReaders}
                                                </span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>

                                {/* DUAL LIST */}
                                <DualListSelector
                                    availableItems={sortedColumns}
                                    securityLevel={securityLevel}
                                    template={Template}
                                    onChange={(selected) => setSelectedFeatures(selected)}
                                    LEVEL1_ALLOWED={LEVEL1_ALLOWED}
                                    LEVEL2_ALLOWED={LEVEL2_ALLOWED}
                                    TEMPLATE_FEATURE_MAP={TEMPLATE_FEATURE_MAP}
                                    isEdit={true}
                                    isSecurityLevelChanged={isSecurityLevelChanged}
                                    onAlert={(msg) => showWarning(msg)}
                                    maxReadsText={maxReadsText}
                                    maxViewsPerDocumentText={maxViewsPerDocumentText}
                                    maxPrintsPerReaderText={maxPrintsPerReaderText}
                                    maxPrintsPerDocumentText={maxPrintsPerDocumentText}
                                    onMaxValueChange={(vals) => {
                                        console.log("Max values changed:", vals);
                                        setMaxReadsPerReader(prev => prev !== vals.maxReadsPerReader ? vals.maxReadsPerReader : prev);
                                        setMaxViewsPerDocument(prev => prev !== vals.maxViewsPerDocument ? vals.maxViewsPerDocument : prev);
                                        setMaxPrintsPerReader(prev => prev !== vals.maxPrintsPerReader ? vals.maxPrintsPerReader : prev);
                                        setMaxPrintsPerDocument(prev => prev !== vals.maxPrintsPerDocument ? vals.maxPrintsPerDocument : prev);
                                    }}
                                    isOpen={isOpen}
                                    onRestrictionValueChange={({ restrictToDomains, allowedIP, bannedRegions }) => {
                                        setRestrictToDomains(prev => prev !== restrictToDomains ? restrictToDomains : prev);
                                        setAllowedIP(prev => prev !== allowedIP ? allowedIP : prev);
                                        setBannedRegions(prev => {
                                            if (Array.isArray(prev) && Array.isArray(bannedRegions)) {
                                                if (prev.length === bannedRegions.length && prev.every((v, i) => v === bannedRegions[i])) {
                                                    return prev;
                                                }
                                            }
                                            return bannedRegions;
                                        });
                                    }}
                                    ConstContinents={bannedRegions}
                                    ConstMultipleIps={allowedIP}
                                    Domains={restrictToDomains}
                                    restrictToDomainLabel={selectedLanguage.LstLanguageCodes.UI_RestrictToDomains}
                                    allowedIPLabel={selectedLanguage.LstLanguageCodes.UI_AllowedIP}
                                    bannedRegionsLabel={selectedLanguage.LstLanguageCodes.UI_BannedRegions}
                                />
                            </div>

                            {/* FOOTER */}
                            <div className="d-flex justify-content-between align-items-center mb-3 mx-3 mt-2">
                                <input
                                    type="text"
                                    value={templateName}
                                    maxLength={25}
                                    onChange={(e) => {
                                        setTemplateName(e.target.value);
                                        templateNameRef.current = true;
                                    }}
                                    style={{ width: "324px", flexShrink: 0, marginLeft: "20px" }}
                                    placeholder="Enter template name"
                                />
                                <div className="d-flex gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-danger px-4"
                                        onClick={handleCancel}
                                    >
                                        {selectedLanguage.LstLanguageCodes.UI_Cancel}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary px-4"
                                        onClick={() =>
                                            handleTemplateCreation({
                                                templateName,
                                                securityLevel,
                                                selectedFeatures
                                            })
                                        }
                                    >
                                        {selectedLanguage.LstLanguageCodes.UI_Update}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {openLoader ? (
                <LoadingSpinner
                    className={openLoaderSearch ? "backgroundTransprent" : undefined}
                />
            ) : null}
            <Alert
                alertType={alertType}
                alertMsg={alertMsg}
                setAlertMsg={setAlertMsg}
                setAlertType={setAlertType}
                className={alertClass}></Alert>
        </>
    );
};

export default EditTemplate;